export { HyamPrismicDocumentPage as default } from "hyam-prismic/components";
export { hyamPrismicDocumentPageGetStaticProps as getStaticProps } from "hyam-prismic/components";
export { hyamPrismicDocumentPageGetStaticPaths as getStaticPaths } from "hyam-prismic/components";
